import React, { Component } from 'react';
import $ from 'jquery';
import { Form, Input, Modal, Button, Select, DatePicker, message, Icon, InputNumber,Radio } from 'antd';
const { TextArea } = Input;
const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY.MM';
import API_URL from '../../common/url';
import InvSiteSearchInput from '../member/InvSiteSearchInput';
import moment from 'moment'
import AjaxRequest from '../../common/AjaxRequest';
import SearchSelect from '../common/SearchSelect';

const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group

/**
 * 搜索企业用户
 */

let timeout;
let currentValue;
let uuid = 0;

class CreateForm extends Component {

    state = {
        city : this.props.city,
        investigationSiteName : '',
        investigationSiteCode : '',
        mode : this.props.mode,
        noFte: this.props.noFte,
        userOptions:[],
        _roleCode : '',
        projectloading: true,
        planBeginTime : '',
        planEndTime: '',
    }

    setFieldsValue = obj => {
        this.props.form.setFieldsValue(obj);
    }

    getEvent = () =>{
        if(document.all){
            return window.event;
        }
        let func = getEvent().caller;
        while (func != null){
            var arg0 = func.arguments[0];
            if(arg0){
                if ((arg0.constructor == Event || arg0.constructor == MouseEvent) || (typeof (arg0) == "object" && arg0.preventDefault && arg0.stopPropagation)){
                    return arg0;
                }
            }
            func = func.caller;
        }
        return null;
    }

    handSelectInvesgationSite = (obj, option) =>{
        this.setState ({
            city : option.city,
        })
        const form = this.props.form;
        form.setFieldsValue({
            invSiteId : obj.key
        })
    }


    

    add = () => {
        const { form } = this.props;
        let keys = form.getFieldValue('keys');
        const startMonthTemp = form.getFieldValue('startMonth');
        if(!startMonthTemp){
            Modal.error({title: `请输入起始时间`})
        }
        const endMonth = form.getFieldValue('endMonth');
        const setFteNum = form.getFieldValue('setFteNum');
        const fteArr = form.getFieldValue('fteArr');
        const getArrIndex = (date) =>{
            let arrIndex = -1;
            fteArr.map((value,index)=>{
                if(value !== 1)
                if(value[0].format('YYYY-MM') == date){
                    arrIndex = index
                }
            })
            return arrIndex;
        }
        if(startMonthTemp && endMonth){
            const startMonth = moment(moment(startMonthTemp).format("YYYY-MM"));
            const formatEndMonth = moment(moment(endMonth).format("YYYY-MM"))
            while (formatEndMonth >= startMonth) {
                const arrIndex = getArrIndex(startMonth.format('YYYY-MM'));
              if(arrIndex < 0){
                fteArr.push([moment(startMonth.format('YYYY-MM')),setFteNum]);
              }else{
                fteArr[arrIndex][1] = setFteNum;
              }
               startMonth.add(1,'month');
            }
        }else if (startMonthTemp){
            const arrIndex = getArrIndex(startMonthTemp.format('YYYY-MM'));
            if(arrIndex < 0){
                fteArr.push([moment(startMonthTemp.format('YYYY-MM')),setFteNum]);
            }else{
                fteArr[arrIndex][1] = setFteNum;
            }
        }
        const sortDate = (a,b) =>{
            if(b !== 1 && a!==1){
                return a[0].format('X') - b[0].format('X')
            }
            
        }
        const fteArrSort = fteArr.sort(sortDate);
        form.setFieldsValue({
            fteArr : fteArrSort,
            keys: Number(keys) + 1
        });
    }

    componentDidMount() {
        uuid = 0;
        const {fteList} = this.props;
        const { form } = this.props;
        const fieldsValue = this.props.form.getFieldsValue();
        let keys = [];
        let FTEDate = [];
        let FTE = [];
        let fteArr = [];
        fteList.map((dataItem, i) => {
            keys.push(i);
            let year =  dataItem.year;
            let month = dataItem.month < 10 ? `0${dataItem.month}` : dataItem.month;
            fteArr.push([moment(`${year}-${month}`),dataItem.fte]);
        });

        form.setFieldsValue({
            fteArr
        });

        let siteId;
        if(sessionStorage.siteId != null && sessionStorage.siteId != 0){
            siteId = sessionStorage.siteId;
        }else{
            const { form } = this.props;
            siteId = form.getFieldValue('invSiteId');
        }
        // if(siteId != null && siteId !=0){
        //     const options = {
        //         url: `${API_URL.site.queryBySiteId}?investigationSiteId=${siteId}`,
        //         dataType: 'json',
        //         doneResult: ( data => {
        //                 this.setState ({
        //                     city : data.data.site.city,
        //                     investigationSiteCode : data.data.site.investigationSiteCode,
        //                     investigationSiteName : data.data.site.investigationSiteName,
        //                 })
        //             }
        //         ),
        //     };
        //     AjaxRequest.sendRequest(options);
        // }
        this.getProjectRegion();
    }

    getProjectRegion = () =>{
        this.setState({
            projectloading: true,
        });
        const options = {
            url: `${API_URL.plan.queryInvestigationStartEnd}`,
            data: {
            },
            dataType: 'json',
            doneResult: ( data => {
                if(data.error){
                    Modal.error({title: data.error});
                    return;
                }
                this.setState({
                    projectloading: false,
                    planBeginTime: data.startTime,
                    planEndTime: data.endTime,
                });
            }),
            errorResult: ( data => {
                
                // this.setState({
                //     projectloading: true,
                // });
            }),
        };
        AjaxRequest.sendRequest(options);
    }

    disabledDate = (current) => {
        const {planBeginTime,planEndTime} = this.state;
        const planBeginTimeValue = moment(moment(planBeginTime).format('YYYY-MM')).valueOf();
        const planEndTimeValue = moment(moment(planEndTime).format('YYYY-MM')).valueOf();
        const currentValue = moment(current.format('YYYY-MM')).valueOf();
        const nowValue =  moment(moment().format('YYYY-MM')).valueOf();
        if(current > nowValue){
            return true;
        } else if(current < planBeginTimeValue){
            return true;
        }
    }
    
    onMonthChange = (index, e) => {
        const { form } = this.props;
        const fteArr = form.getFieldValue('fteArr');
        fteArr[index][0] = e;
        form.setFieldsValue({
            fteArr
        });
    }

    onNumberChange = (index, e) => {
        const { form } = this.props;
        const fteArr = form.getFieldValue('fteArr');
        fteArr[index][1] = e;
        form.setFieldsValue({
            fteArr
        });
    }
    
    remove = (index) => {
        const { form } = this.props;
        
        const fteArr = form.getFieldValue('fteArr');
        fteArr.splice(index, 1)
        
        form.setFieldsValue({
            fteArr
        });
    }

    parserDataUser = (dt,value) => {
        const { form } = this.props;
        if(!value){
            form.setFieldsValue({
                userId : {}
            })
        }
        if ((dt.data || dt.datas) ) {
            const sourceData = dt.data ? dt.data.crcList: dt.datas;
            const data = sourceData.map(r => ({
                text: `${r.userCompellation}[${r.employeeCode}]`,
                value: r.userId,
            }));
            this.setState({
              userOptions:data,
              // enterpriseWorkCategories:dt.data.enterpriseWorkCategories
            });
        } else {
            this.setState({
              userOptions: [],
            });
        }
      };

      userSelectChanged=(value)=>{
        const { form } = this.props;
        form.setFieldsValue({
            userId : value
        })
      }


      handleFormLayoutChange = (e) => {
        this.setState({ _roleCode: e.target.value });
      }

    render() {
        
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const {city} = this.state;
        const {investigationSiteName,
        investigationSiteCode,
        userCompellation,
        employeeCode,
        roleCode} = this.props;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 20, offset: 4 },
            },
        };
        getFieldDecorator('fteArr', { initialValue: [] });
        getFieldDecorator('keys', { initialValue: 0 });
        getFieldDecorator('ftes', { initialValue: [] });
        getFieldDecorator('FTEDate', { initialValue: [] });
        getFieldDecorator('startMonth', { initialValue: null });
        getFieldDecorator('endMonth', { initialValue: null });
        getFieldDecorator('setFteNum', { initialValue: null,rules: [
            {
                required: true,
                message: "请输入FTE数量!"
            }
        ] });
        
        const fteArr = getFieldValue('fteArr');
        const keys = getFieldValue('keys');
        const ftes = getFieldValue('ftes');
        const FTEDate = getFieldValue('FTEDate');
        const startMonth = getFieldValue('startMonth');
        const endMonth = getFieldValue('endMonth');
        const setFteNum = getFieldValue('setFteNum');
        
        let invSiteId = getFieldValue('invSiteId');
        if (invSiteId == null || invSiteId == undefined){
            invSiteId = "";
        }
        let invSiteName = getFieldValue('invSiteName');
        let userId = getFieldValue('userId');
        //let investigationSiteCode = getFieldValue('investigationSiteCode');
        if (invSiteName == null || invSiteName == undefined){
            invSiteName = "";
        }
        let defaultSite = {"key":invSiteName, "label":invSiteName}
        const siteId = sessionStorage.siteId;
        var dNow = new Date();
        const curYear = dNow.getFullYear();
        const curMonth = dNow.getUTCMonth() + 1; //取出来都是当前月份-1的值，不知道为啥
        const formItems = fteArr.map((value,fteKey)=>{
            let canDateEdit = true;
            let cnaFteEdit = true;
            let canDelete = true;
            if(this.state.mode == 'change'){
                canDelete = false;
                const now = moment(moment().format('YYYY-MM')).format('x');
                if( now > value[0].format('x')){
                    canDateEdit = false;
                }
                if(now > value[0].format('x')){
                    cnaFteEdit = false;
                }
                if( now < value[0].format('x')){
                    canDelete = true;
                }else if( now == value[0].format('x') && this.state.noFte){
                    canDelete = true;
                }
            }
            return (
                
                <FormItem
                {...(fteKey === 0 ? formItemLayout : formItemLayout)}
                label={fteKey === 0 ? '' : ''}
                required={false}
                key={fteKey}
                style={{marginLeft:'25px'}}
            >

                    <MonthPicker className="FTETime"  
                                format={monthFormat}
                                value = {value[0]}
                                disabled= {!canDateEdit}//{ !canDateEdit ? "disabled" : "" }
                                style={{marginLeft:'20px',width:'100px'}}
                                disabledDate={this.disabledDate}
                                onChange = {this.onMonthChange.bind(this,fteKey)}
                                />
                
                    <InputNumber className="FTENum"  
                    placeholder="FTE数量" 
                    style={{width:'80px', marginLeft:'20px'}}
                    value = {value[1]}
                    onChange = {this.onNumberChange.bind(this,fteKey)}
                    step={0.1}
                    precision={2}
                    formatter={value => value !== value || (!value && value !== 0) ? '' : value}
                    disabled= {!cnaFteEdit}//{ !cnaFteEdit ? "disabled" : "" }
                    />
                    
                
                {canDelete ? (
                        <Icon
                            className="dynamic-delete-button"
                            type="minus-circle-o"
                            disabled={keys.length === 1}
                            onClick={() => this.remove(fteKey)}
                        />
                    ) : null}
                    
            </FormItem>
            )

        })


        const returnStr = (
            <div className="create-form create-require">
                <Form>

                    <div className="field-max">
                    {this.state.mode == "edit" ?
                    <div className = "ant-row ant-form-item" style={{marginBottom: '0px'}}> 
                        <div className="ant-form-item-label" style={{width: '120px'}}>
                        <label id="city" className="" title="工时对应角色">工时对应角色</label>
                        </div> 
                        <div className = "ant-form-item-control-wrapper" > 
                            <div className="ant-form-item-control ">
                                    <span>{roleCode}</span>
                            </div> 
                        </div>
                    </div>
                    :
                    <FormItem label="工时对应角色" className="inv-siteId" style={{marginBottom: '0px'}} >
                        {
                                getFieldDecorator('roleCode',{
                                    rules: [
                                        { required: true, message: '角色不能为空' },
                                    ],
                                    initialValue:'CRC'
                                })(
                                    <RadioGroup  onChange={this.handleFormLayoutChange}>
                                      <Radio value="CRC">CRC</Radio>
                                      <Radio value="PM">PM</Radio>
                                      <Radio value="PA">PA</Radio>
                                    </RadioGroup>
                                  )
                        }
                    </FormItem>
                    }
                    </div>


                      
                    <div className="field-max">

                        {this.state.mode == "edit" ?
                        <div className = "ant-row ant-form-item" style={{marginBottom: '0px'}}> 
                            <div className="ant-form-item-label" style={{width: '120px'}}>
                            <label id="city" className="" title="中心名称(中心编号)">中心名称(中心编号)</label>
                            </div> 
                            <div className = "ant-form-item-control-wrapper" > 
                                <div className="ant-form-item-control ">
                                        {investigationSiteName != null?
                                        <span>{investigationSiteName}({investigationSiteCode})</span>:
                                        <span>-</span>}
                                </div> 
                            </div>
                        </div>

                        :
                        <FormItem label="中心名称(中心编号)" className="inv-siteId" style={{marginBottom: '0px'}}>
                            {
                                this.state._roleCode == 'CRC' || this.state._roleCode == ''?
                                getFieldDecorator('invSiteId', {
                                    rules: [
                                        { required: true, message: '中心不能为空' },
                                    ],
                                })(
                                    <InvSiteSearchInput labelInValue
                                                        placeholder="请在此输入中心名称\中心编号"
                                                        handSelectInvesgationSite = {this.handSelectInvesgationSite}
                                                        inputChange = {this.inputChange}
                                                        initValue = {defaultSite}
                                    />) :'-'
                            }
                        </FormItem>

                        }
                    </div>
                    <div className="field-max">

                        {this.state.mode == "edit" ?
                        <div className = "ant-row ant-form-item" style={{marginBottom: '0px'}}> 
                            <div className="ant-form-item-label" style={{width: '120px'}}>
                            <label id="city" className="" title="CRC">人员</label>
                            </div> 
                            <div className = "ant-form-item-control-wrapper" > 
                                <div className="ant-form-item-control ">
                                        <span>{userCompellation}({employeeCode})</span>
                                </div> 
                            </div>
                        </div>

                        :
                        <FormItem label="人员" className="inv-siteId" style={{marginBottom: '0px'}}>
                            {
                                getFieldDecorator('userId', {
                                    rules: [
                                        { required: true, message: '人员不能为空' },
                                    ],
                                })(
                                    <SearchSelect 
                                        style={{width:130}}
                                        url = {API_URL.team.userlist}
                                        searchKey = 'keyword'
                                        sourceData={this.state.userOptions}
                                        parserData={this.parserDataUser}
                                        handleSelect = {this.userSelectChanged}
                                        placeholder={'输入名字或工号'}
                                        allowClear={true}
                                        className=''
                                    />)
                            }
                        </FormItem>

                        }
                    </div>
                    <div className="field-max">
                        <FormItem label="实际FTE" style={{marginBottom: '5px'}}>
                            {getFieldDecorator('startMonth', startMonth)(
                                this.state.mode == "change" ?
                                <MonthPicker style={{width:'100px',marginRight:'5px'}} placeholder='起始时间' disabledDate={this.disabledDate} />
                                :
                                <MonthPicker style={{width:'100px',marginRight:'5px'}} placeholder='起始时间' disabledDate={this.disabledDate} />
                                
                            )}
                                -
                            {getFieldDecorator('endMonth', endMonth)(
                                this.state.mode == "change" ?
                                <MonthPicker style={{width:'100px',marginLeft:'5px'}} placeholder='截止时间'  disabledDate={this.disabledDate} />
                                :
                                <MonthPicker style={{width:'100px',marginLeft:'5px'}} placeholder='截止时间' disabledDate={this.disabledDate} />
                            )}
                            {getFieldDecorator('setFteNum', setFteNum)(
                                <InputNumber className="FTENum"  
                                placeholder="月均FTE数" 
                                style={{width:"80px",marginLeft:'10px'}}
                                formatter={value => value !== value ? '' : value}
                                step={0.1}
                                precision={2}
                                //disabled= {!cnaFteEdit}//{ !cnaFteEdit ? "disabled" : "" }
                                />
                            )}
                            {
                                (<Button onClick={this.add}>添加\更新</Button>)
                            }
                        </FormItem>
                        <div className="fte-scroll">
                        {formItems}
                        </div>
                    </div>
                </Form>
            </div>
        )
        


        return (
            returnStr
        );
    }
}

class CreateModal extends Component {

    state = {
        visible: false,
        confirmLoading: false,
        copy: false,
        requirement: {},
        site : {},
        isEdit: false,
        invSiteId : '',
        fteList : [],
        requirementId : '',
        city : '',
        display : 'none',
        mode : 'add',
        noFte: true,
        planBeginTime: null,
        planEndTime: null,
        
    };

    show = (record = {}, m) => {
        this.setState({
            visible: true,
            isEdit: false,
            requirement: {},
            requirementId: '',
            site : {},
            invSiteId : '',
            fteList : [],
            city : '',
            planBeginTime: this.props.planBeginTime,
            planEndTime: this.props.planEndTime,
            ...record
        });
        if (m == "edit") {
            this.setState({
                mode : 'edit',
                isEdit: true,
             })
        }
        else{
             this.setState({
                mode : 'add',
             }) 
        }
    };


    hide = () => {
        this.setState({
            visible: false,
        });
    };

    // 提交表单
    handleSubmit = () => {
        this.refs.form.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            //this.setState({ confirmLoading: true });
            const fieldsValue = this.refs.form.getFieldsValue();
            const FTEDateAry = fieldsValue.FTEDate;
            const FTE = fieldsValue.FTE;
            const fteArr = fieldsValue.fteArr;
            //const fteMap = fieldsValue.fteMap;
            let needData = 0;
            let needNumber = 0;
            fteArr.map((value, index) => {
                if(value[0] === null || value[0] === undefined){
                    needData++;
                }
                if(value[1] === null || value[1] === undefined){
                    
                    needNumber++
                }
            })
            if(needData > 0){
                Modal.error({title:"尚有日期未选择"});
                return;
            }
            if(needNumber > 0){
                Modal.error({title:"尚有FTE数量未填写"});
                return;
            }
            // let ftesStr = '';
            const fteObj = {};
            fteArr.map((value, index) => {
                const year = value[0].format("YYYY");
                const month = value[0].format("MM");
                const fteNum = value[1];
                fteObj["ftes["+index+"].year"] =year;
                fteObj["ftes["+index+"].month"] = month;
                fteObj["ftes["+index+"].fte"] = fteNum;
            });
            
            
            const userId = fieldsValue.userId && fieldsValue.userId.key;
            let comment = {};
            

            let roleCode = fieldsValue.roleCode;
            let param = "roleCode="+roleCode;
            let invSiteId = fieldsValue.invSiteId;
            if(invSiteId == null || invSiteId == undefined){
                invSiteId = sessionStorage.siteId;
            }else{
                param += "&investigationSiteId="+invSiteId;
            }
            // if(ftesStr != ""){
            //     param += ftesStr;
            // }
            this.setState({
                confirmLoading : true
            });
            if (this.state.isEdit) {
                let options ={};
                        // 修改
                         options = {
                            method: 'POST',
                            url: `${API_URL.sumtotal.modifyInvestigationFte}`,
                            data:{
                                userId: this.state.userId,
                                ...fteObj,
                                investigationSiteId: this.state.investigationSiteId,
                                roleCode:this.state.roleCode
                            },
                            doneResult: ( data => {
                                    this.setState({ confirmLoading: false });
                                    message.success('修改成功');
                                    this.props.reload();
                                    this.hide();
                                }
                            ),
                            errorResult: (() => {
                                this.setState({confirmLoading: false});
                            }),
                            failResult: (() => {
                                this.setState({confirmLoading: false});
                            }),
                        };
                AjaxRequest.sendRequest(options);
            } else {
                // 新建
                
                const options = {
                    method: 'POST',
                    url: `${API_URL.sumtotal.inputInvestigationFte}?${param}`,
                    data:{
                        userId,
                        ...fteObj,
                    },
                    doneResult: ( data => {
                          
                            this.setState({ visible : false,confirmLoading: false });
                            message.success('新建成功');
                            this.props.reload();
                            this.hide();
                        }
                    ),
                    errorResult: (() => {
                        this.setState({confirmLoading: false});
                     }),
                    failResult: (() => {
                        this.setState({confirmLoading: false });
                    }),
                };
                AjaxRequest.sendRequest(options);
            }
        });
    }

    render() {
        const { confirmLoading, investigationSiteName, investigationSiteCode,userId, userCompellation, employeeCode, visible, requirement, site, city, fteList, isEdit, mode, copy, noFte, planEndTime, planBeginTime,roleCode } = this.state;
        const mapPropsToFields = () => ({
            invSiteId: { value: site.investigationSiteId },
            comment: { value: requirement.requirementComment},
            invSiteName: { value: site.investigationSiteName },
        });
        CreateForm = Form.create({ mapPropsToFields })(CreateForm);
        const newTitle = "添加数据";
        const title = "修改数据";
        return (
            <Modal
                title={isEdit ? title : newTitle }                
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal requirement-create"
                wrapClassName="vertical-center-modal create-require-modal"
                width="650px"
                confirmLoading={confirmLoading}
            >
                <CreateForm ref="form" 
                    mode={this.state.mode}
                    planBeginTime = {planBeginTime}
                    planEndTime = {planEndTime}
                    investigationSiteName={investigationSiteName}
                    investigationSiteCode={investigationSiteCode}
                    userCompellation={userCompellation}
                    employeeCode={employeeCode}
                    roleCode={roleCode}
                    userId={userId}
                    noFte={noFte} city={city} fteList={fteList} />
            </Modal>

        );
    }
}

export default CreateModal;



// WEBPACK FOOTER //
// ./src/components/sumTotal/LeakCreateModal.js